/**
 * Ephemeral live-session emoji reactions (LiveKit data channel).
 */

export const LIVE_REACTION_TYPE = "codelive.reaction" as const;

/** Zoom-style quick reactions strip. */
export const LIVE_REACTION_EMOJIS = [
  "👍",
  "👏",
  "❤️",
  "😂",
  "😮",
  "🎉",
  "🔥",
  "🙌",
] as const;

export type LiveReactionEmoji = (typeof LIVE_REACTION_EMOJIS)[number] | string;

export type LiveReactionMessage = {
  type: typeof LIVE_REACTION_TYPE;
  v: 1;
  reaction_id: string;
  emoji: string;
  from_id: string;
  from_name: string;
  at: number;
};

export type FloatingReaction = {
  reaction_id: string;
  emoji: string;
  from_name: string;
  at: number;
  /** Horizontal offset 0–100 (%) so bursts don't stack. */
  x: number;
};
